module.exports = __webpack_public_path__ + "static/esco-4-26190de8b61bab0da9c29439d68f7923.jpeg";